import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M8 1.252A6.75 6.75 0 1 0 14.749 8 6.76 6.76 0 0 0 8 1.252Zm0 12A5.25 5.25 0 1 1 13.249 8 5.255 5.255 0 0 1 8 13.252Zm1.9-2.78v.95H6.018v-.95h1.43v-4.69l-1.21.6-.46-.82 1.96-1.14h.93v6.05Z';
const draw24px = 'M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM12,3.47A8.53,8.53,0,1,0,20.53,12,8.54,8.54,0,0,0,12,3.47ZM15,15.83V17.3h-6V15.83h2.22V8.57L9.28,9.5,8.57,8.23l3-1.76H13v9.36Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const CountIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'count'));
CountIcon.displayName = 'CountIcon';
CountIcon.propTypes = Icon.propTypes;
CountIcon.renderIcon = props => /*#__PURE__*/React.createElement(CountIcon, props);
export default CountIcon;
//# sourceMappingURL=CountIcon.js.map